import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {EmailVerificationState} from "../domain";
import {Auth} from "@angular/fire/auth";
import {LoggerService} from "./logger.service";


@Injectable({ providedIn: 'root' })
export class EmailVerificationService {
  private readonly stateSubject = new BehaviorSubject<EmailVerificationState>({
    checkInProgress: false,
    required: false,
  });

  readonly state$ = this.stateSubject.asObservable();

  constructor(
    private readonly auth: Auth,
    private readonly logger: LoggerService,
  ) {}

  setVerificationRequired(email?: string): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      required: true,
      email
    });
  }

  clearVerificationRequired(): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      required: false
    });
  }

  setLoadingState(isLoading: boolean): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      checkInProgress: isLoading
    })
  }

  async checkEmailVerification(): Promise<boolean> {
    this.setLoadingState(true)

    try {
      const user = this.auth.currentUser
      if (user) {
        await user.reload()
        this.logger.info("User reloaded from Firebase", {emailVerified: user.emailVerified})

        if (user.emailVerified) {
          this.clearVerificationRequired()

          return true
        }
      }

      return false;
    } catch (error) {
      this.logger.error("Failed check email verification from Firebase!", error);

      return false;
    } finally {
      this.setLoadingState(false)
    }
  }
}
